<template lang="pug">
a.link(
  v-bind="$attrs"
  :href="props.href"
  :style="{ scrollBehavior: props.scrollBehavior }"
)
  span(v-if="props.text") {{ props.text }}
  slot
</template>

<script setup lang="ts">
import { type AnchorPatternProps } from './AnchorPattern.types';
import { anchorPatternDefaults } from './AnchorPattern.defaults';

const props = withDefaults(
  defineProps<AnchorPatternProps>(),
  anchorPatternDefaults as any,
) as unknown as AnchorPatternProps;
</script>
